export function initBreadCrumb() {
    const breadcrumbList = document.querySelector('.modBreadcrumbs');
    if (!breadcrumbList) return;

    if (document.body.classList.contains('error404') || document.querySelector('main.error')) {
        breadcrumbList.innerHTML = `
            <li class="modBreadcrumbs__item">
                <a href="/" class="modBreadcrumbs__item__link">トップ</a>
            </li>
            <li class="modBreadcrumbs__item">
                <span class="modBreadcrumbs__item__current" aria-current="page">404</span>
            </li>
        `;
        return;
    }

    const path = window.location.pathname;

    let segments = path.split('/')
        .filter(segment => segment !== '' && segment !== 'index.php');
    
    const pageIndex = segments.indexOf('page');
    if (pageIndex !== -1) {
        segments = segments.slice(0, pageIndex);
    }
    
    const SKIP_SEGMENTS = [
        'product-category',
        'category',
        'tag',
    ];

    segments = segments.filter(segment => !SKIP_SEGMENTS.includes(segment));

    const PAGE_DATA = {
        'reason': '選ばれる理由',
        'oem': '化粧品OEM/ODM',
        'products': '取り扱い商品 一覧',
        'rd': '研究開発',
        'factory': '工場案内',
        'production': '生産体制/生産設備',
        'quality': '品質管理/品質保証',
        'company': '会社情報',
        'message': 'トップメッセージ',
        'philosophy': '企業理念',
        'profile': '会社概要',
        'news': 'お知らせ一覧',
        'white_paper': 'お役立ち資料一覧',
        'contact': 'お問い合わせフォーム',
        'column': 'コラム一覧',
        'privacy_policy': 'プライバシーポリシー',
        'download': 'お役立ち資料ダウンロード'
    };

    let breadcrumbHtml = `
        <li class="modBreadcrumbs__item">
            <a href="/" class="modBreadcrumbs__item__link">トップ</a>
        </li>
    `;

    let currentPath = '/';
    
    const getPageTitle = () => {
        return document.title.split('|')[0].trim();
    };

    segments.forEach((segment, index) => {
        const isLast = index === segments.length - 1;
        const cleanSegment = segment.replace('.php', '');
        
        currentPath += `${cleanSegment}/`;
        
        let label = '';
        if (isLast) {
            if (segments.length > 2) {
                label = PAGE_DATA[cleanSegment] || getPageTitle();
            } else {
                label = getPageTitle();
            }
        } else {
            label = PAGE_DATA[cleanSegment] || cleanSegment;
        }

        if (isLast) {
            breadcrumbHtml += `
                <li class="modBreadcrumbs__item">
                    <span class="modBreadcrumbs__item__current" aria-current="page">${label}</span>
                </li>
            `;
        } else {
            breadcrumbHtml += `
                <li class="modBreadcrumbs__item">
                    <a href="${currentPath}" class="modBreadcrumbs__item__link">${label}</a>
                </li>
            `;
        }
    });

    breadcrumbList.innerHTML = breadcrumbHtml;
}
